const {jQuery: $} = window;
import Utils from "./utils.class";
import Featherlight from "./../lib/featherlight";
import Cookies from 'js-cookie';
import Hubspot from "./Hubspot.class";

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #config;
    #scrollOffset;
    #scrollSpeed;
    #utils;
    #$admin;
    #root;
    #hubspot;
    #cmp;

    #counter;

    constructor(
        config,
        utils,
    ) {
        this.#config = config;
        this.#utils = utils;
        this.#scrollOffset = 0;
        this.#root = document.querySelector(":root");

        this.#scrollSpeed = 750;
        this.$html = $('html');

        this.$body = $('body');
        this.$main = $('#site-wrapper');
        this.$header = $('header.elementor-location-header');
        this.#$admin = $('#wpadminbar');
        this.#counter = $('.counter__number');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", "1");
        }

        this.$header.addClass('fixed');

        Utils.log("Theme Config:", config);

        this.#hubspot = new Hubspot("6505100", this.#cmp);
    }

    __onReady() {
        const me = this;

        Utils.log("Theme Ready");

        $('a').each(function(i, el) {
            var url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags
            if(url) {
                if(url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)){
                    var id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube.com/embed/" + id + "?rel=0&amp;autoplay=1" );

                    $(el).featherlight();
                }
            }
        });

        let socialMenu = [];
        if(this.#config.social.facebook) {
            socialMenu.push(`<a href='${this.#config.social.facebook}' target='_blank'><i class='fa fa-facebook'></i></a>`)
        }

        if(this.#config.social.twitter) {
            socialMenu.push(`<a href='${this.#config.social.twitter}' target='_blank'><svg style="padding: 12px;color: #858585;fill:#858585;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg></a>`)
        }

        if(this.#config.social.youtube) {
            socialMenu.push(`<a href='${this.#config.social.youtube}' target='_blank'><i class='fa fa-youtube'></i></a>`)
        }

        if(this.#config.social.linkedin) {
            socialMenu.push(`<a href='${this.#config.social.linkedin}' target='_blank'><i class='fa fa-linkedin'></i></a>`)
        }

        if(this.#config.social.instagram) {
            socialMenu.push(`<a href='${this.#config.social.instagram}' target='_blank'><i class='fa fa-instagram'></i></a>`)
        }

        var menu = new window.Mmenu("#menu-wrapper", {
            "offCanvas": {
                "position": "right-front"
            },
            "theme": "dark",
            "counters": {
                "add": false
            },
            "iconbar": {
                "use": true,
                "top": [
                    "<a href='https://bigleaf.net/'><i class='fa fa-home'></i></a>",
                    "<a href='https://auth.bigleaf.net/login?state=hKFo2SAxNmRxWXlNdzRDOWxVcTVaWk1UaWlkVEJSZlRjenZXUKFupWxvZ2luo3RpZNkgTUZHcTU3blZJM1pZSFhSLWJfVkFDN3QxU1hneVNKSE2jY2lk2SBxRXM1cUFabVVUZ1JkcW5WemNnQVhIWmR5WU83bndyTA&client=qEs5qAZmUTgRdqnVzcgAXHZdyYO7nwrL&protocol=oauth2&response_type=code&redirect_uri=https%3A%2F%2Fapp.bigleaf.net%2Fcallback&realm=app-retail&scope=openid%20profile%20email'><i class='fa fa-user'></i></a>"
                ],
                "bottom": socialMenu
            }
        }, {
            "offCanvas": {
                "page": {
                    "selector": "#site-wrapper"
                }
            }
        });

        $('.mmenu-nav').on('click', function (evnt) {
            evnt.preventDefault();
            menu.API.open()
        })


        $(".html_menu .menu > .menu-item-has-children").on("mouseenter", function() {
            const $this = $(this);
            const $parent = $this.parents(".menu");
            $parent.find(".js-active").removeClass("js-active");
            $this.addClass("js-active");

            const menuWatcher = setInterval(() => {
                if(!$this.is(":hover")) {
                    $this.removeClass("js-active");
                    clearInterval(menuWatcher);
                }
            }, 2000);
        });
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");
        this.#$admin = $('#wpadminbar');

        $(window).trigger("resize");

        // if (location.hash) {
        //     Utils.log("Scroll to Section Load");
        //
        //     setTimeout(function () {
        //         Utils.scrollToHash(location.hash, null, me.scrollOffset, me.#scrollSpeed);
        //
        //     }, 300);
        // }

        $('.search-button').on('click', function () {
            $('.searchwrap').toggleClass('open');
        });

    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }

    activatePlayer() {
        // TODO: Implement video platform integration
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        if (this.#$admin.length > 0) {
            return this.$header.outerHeight() + this.#$admin.outerHeight();
        }

        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        return this.#scrollOffset + this.headerHeight + subNav;
    }

    get CMP() {
        return this.#cmp;
    }

    #updateCssHeaderHeight() {
        this.#root.style.setProperty('--header-height', this.headerHeight + "px");
    }
}